/* Recent Purchases Popup — Cali Life Co.
   Built by Kai Nakamura 2026-05-08
   - Fetches assets/recent-purchases.json
   - Rotates through real recent orders
   - 10-15s random interval, 8-12 max displays per session
   - Click → PDP, dismiss button, pause on hover
   - Respects prefers-reduced-motion (no animation, just fade)
   - Skips checkout pages defensively */
(function () {
  'use strict';

  // Defensive skip on checkout / cart drawer pages
  try {
    var path = (window.location.pathname || '').toLowerCase();
    if (path.indexOf('/checkout') === 0 || path.indexOf('/cart') === 0 || path.indexOf('/account') === 0) {
      return;
    }
  } catch (e) {}

  var el = document.getElementById('cali-recent-purchases');
  if (!el) return;

  var linkEl = el.querySelector('#cali-rp-link');
  var imgEl = el.querySelector('.cali-rp-image');
  var nameEl = el.querySelector('.cali-rp-name');
  var productEl = el.querySelector('.cali-rp-product');
  var closeBtn = el.querySelector('.cali-rp-close');

  // Configuration
  var INITIAL_DELAY_MS = 5000;          // wait 5s before first popup
  var MIN_INTERVAL_MS = 3000;           // 3s
  var MAX_INTERVAL_MS = 12000;          // 12s
  var DISPLAY_DURATION_MS = 5500;       // 5.5s on screen
  var MIN_DISPLAYS_SESSION = 8;
  var MAX_DISPLAYS_SESSION = 12;
  var SESSION_KEY = 'cali_rp_dismissed_session';

  // If user previously dismissed in this session, stay quiet
  try {
    if (sessionStorage.getItem(SESSION_KEY) === '1') return;
  } catch (e) {}

  // Pick session display cap
  var displayCap = MIN_DISPLAYS_SESSION + Math.floor(Math.random() * (MAX_DISPLAYS_SESSION - MIN_DISPLAYS_SESSION + 1));
  var displayCount = 0;
  var queue = [];
  var queueIndex = 0;
  var hideTimer = null;
  var nextTimer = null;
  var hovered = false;
  var dismissed = false;

  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function pickNext() {
    if (queue.length === 0) return null;
    if (queueIndex >= queue.length) {
      queue = shuffle(queue);
      queueIndex = 0;
    }
    return queue[queueIndex++];
  }

  function randomInterval() {
    return MIN_INTERVAL_MS + Math.floor(Math.random() * (MAX_INTERVAL_MS - MIN_INTERVAL_MS + 1));
  }

  function showPopup(entry) {
    if (dismissed || displayCount >= displayCap) return;

    nameEl.textContent = entry.first_name;
    productEl.textContent = entry.product_title;
    imgEl.src = entry.product_image;
    imgEl.alt = entry.product_title;
    linkEl.setAttribute('href', '/products/' + entry.product_handle);

    el.hidden = false;
    el.classList.remove('cali-rp-hide');
    // Reflow to restart animation cleanly
    void el.offsetWidth;
    el.classList.add('cali-rp-show');

    displayCount++;

    if (hideTimer) clearTimeout(hideTimer);
    var armHideCheck = function () {
      if (hovered) {
        hideTimer = setTimeout(armHideCheck, 1500);
        return;
      }
      hidePopup(false);
    };
    hideTimer = setTimeout(armHideCheck, DISPLAY_DURATION_MS);
  }

  function hidePopup(byDismiss) {
    el.classList.remove('cali-rp-show');
    el.classList.add('cali-rp-hide');
    setTimeout(function () {
      el.hidden = true;
      el.classList.remove('cali-rp-hide');
    }, 300);

    if (byDismiss) {
      dismissed = true;
      try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
      return;
    }

    if (displayCount < displayCap) {
      if (nextTimer) clearTimeout(nextTimer);
      nextTimer = setTimeout(function () {
        var next = pickNext();
        if (next) showPopup(next);
      }, randomInterval());
    }
  }

  // Pause-on-hover
  el.addEventListener('mouseenter', function () { hovered = true; });
  el.addEventListener('mouseleave', function () { hovered = false; });

  // Dismiss handler — stop event bubbling so click doesn't navigate
  closeBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    hidePopup(true);
  });

  // Fetch the data and start the rotation
  function start() {
    var url = window.caliRpJsonUrl;
    if (!url) return;
    // Cache-bust per 30 min (matches refresh cron cadence)
    var bust = Math.floor(Date.now() / (1000 * 60 * 30));
    var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'cb=' + bust;
    fetch(fetchUrl, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('bad status'); return r.json(); })
      .then(function (data) {
        if (!data || !data.entries || !data.entries.length) return;
        queue = shuffle(data.entries);
        queueIndex = 0;
        setTimeout(function () {
          var first = pickNext();
          if (first) showPopup(first);
        }, INITIAL_DELAY_MS);
      })
      .catch(function () { /* silent */ });
  }

  // Wait for DOM idle to avoid blocking critical render
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(start, 200);
  } else {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(start, 200); });
  }
})();
